function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcpStackdriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#aecbfa"
    },
    d: "m11.19 11.35 4.56-7.84h-9l-4.5 7.84h8.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4285f4"
    },
    d: "m2.25 12.65 4.49 7.84h8.99l-4.48-7.84h-9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.75 12-4.5-7.87L12.74 12l4.51 7.87Z",
    style: {
      fill: "#669df6"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpStackdriver);
export default __webpack_public_path__ + "static/media/gcp-stackdriver.a72b4a97.svg";
export { ForwardRef as ReactComponent };